<!-- 教学计划 -->
<template>
    <div class="el-teachingPlan">
        <el-row class="page_content">
            <h1 class="head_title">教学计划</h1>
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="课程类别">
                    <el-select v-model="form.region" :filterable="true" @change="selectScore" placeholder="请选择学期">
                        <el-option label="所有" value=""></el-option>
                        <el-option label="公共课" value="公共课"></el-option>
                        <el-option label="专业基础课" value="专业基础课"></el-option>
                        <el-option label="专业课" value="专业课"></el-option>
                        <el-option label="实践教学" value="实践教学"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="courseTypeConcat"
                    header-align="center"
                    align="center"
                    label="课程类别"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="courseName"
                    header-align="center"
                    align="center"
                    label="课程名称"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="courseNatureConcat"
                    header-align="center"
                    align="center"
                    label="课程性质">
                </el-table-column>
                <el-table-column
                    prop="semestersText"
                    header-align="center"
                    align="center"
                    label="学期"
                    v-if="!this.$strExistHostnameOnce(['localhost', 'lfjtysxx'])"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="合计">
                    <template slot-scope="scope">
                      {{scope.row.courseClassTime + scope.row.operateComputerTime + scope.row.practiceTime +scope.row.teachOneselfTime}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="courseClassTime"
                    header-align="center"
                    align="center"
                    label="线上教学">
                </el-table-column>
                <el-table-column
                    prop="operateComputerTime"
                    header-align="center"
                    align="center"
                    label="上机学时">
                </el-table-column>
                <el-table-column
                    prop="practiceTime"
                    header-align="center"
                    align="center"
                    label="实验实训">
                </el-table-column>
                <el-table-column
                    prop="teachOneselfTime"
                    header-align="center"
                    align="center"
                    label="线下教学">
                </el-table-column>
                <el-table-column
                    prop="credit"
                    header-align="center"
                    align="center"
                    label="总学分">
                </el-table-column>
                <el-table-column
                    prop="examCheckType"
                    header-align="center"
                    align="center"
                    label="考核方式">
                    <template slot-scope="scope">
                      {{$examCheckType(scope.row.examCheckType)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="isOnline"
                    header-align="center"
                    align="center"
                    v-if="!this.$strExistHostnameOnce(['localhost', 'czvtc'])"
                    label="是否网学">
                    <template slot-scope="scope">
                        <el-link type="primary" v-if="scope.row.isOnline == 1" :underline="false">是</el-link>
                        <el-link type="primary" v-if="scope.row.isOnline == 2" :underline="false">否</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
export default {
  name: "TeachingPlan",
  data() {
    return {
        form:{
            region:""
        },
        tableData: [],
        courseTypeConcat:"" //课程类别
    };
  },
  created() {
    this.getTeachingPlanCourse();
  },
  methods: {
    selectScore(v){
      this.courseTypeConcat = v;
      this.getTeachingPlanCourse();
    },
    getTeachingPlanCourse(){ //获取教学计划List
      this.$store.dispatch("user/getTeachingPlanCourse",{courseTypeConcat:this.courseTypeConcat}).then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          this.tableData = ret.data;
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
      })
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-teachingPlan{
    .wd{
        color: @red;
    }
    .el-dialog__body{
        border-top:1px solid #ebeef5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/teachingPlan/TeachingPlan.vue